import Layout1 from "./Layout1";

export { Layout1 };
export default {
  Layout1,
};
